import { IHttpErrorPayload } from "@core/models";
 export interface VerifyotpMaintanence {
  verifyotp: Verifyotp[];
}
export interface Verifyotp  {
        mode:string, 
        sourceReference:string, 
        processCode:string, 
        otp:string, 
        stageCode:string, 
  }
  
  
 export interface VerifyotpResponse {
    inventoryNo? : string ;
    httpStatus? : number;
    error? : IHttpErrorPayload;
}	




